import { render } from "./Dots.vue?vue&type=template&id=46a9b380&scoped=true"
import script from "./Dots.vue?vue&type=script&lang=js"
export * from "./Dots.vue?vue&type=script&lang=js"

import "./Dots.vue?vue&type=style&index=0&id=46a9b380&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a9b380"]])

export default __exports__